import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { LabelOff } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const RemoveTagNode = memo(({ id, data, isConnectable, selected }) => {
  const tagName = data?.tagName || data?.tag?.name;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<LabelOff />}
      title="Remover Tag"
      color="#dc3545"
      bgColor="#FFF5F5"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: tagName ? "#FDECEA" : "#f5f5f5",
          color: tagName ? "#dc3545" : "#999",
          border: `1px solid ${tagName ? "#dc354530" : "#e0e0e0"}`,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <LabelOff style={{ fontSize: 13, color: tagName ? "#dc3545" : "#bbb" }} />
        <span style={{ textDecoration: tagName ? "line-through" : "none" }}>
          {tagName || "Nenhuma tag"}
        </span>
      </div>
    </NodeWrapper>
  );
});

RemoveTagNode.displayName = "RemoveTagNode";
export default RemoveTagNode;
